import { to_euro } from '../utils/utils';
import SettingStruct from '../utils/SettingStruct';

import gekoLight from '../assets/img/geko_logo_mini.webp';
import gekoDark from '../assets/img/geko_logo_mini_dark.webp';
import { useState } from 'react';

// kParse [ friendly name, css color, text color ]
const kParse = {
  'XAU'    : [ 'Oro'        ,'gold-bg'  , 'gold'   ],
  'XAG'    : [ 'Argento'    ,'silver-bg', 'silver' ],
  'XAUPAC' : [ 'Oro pac'    ,'gold-bg'  , 'gold'   ],
  'XAGPAC' : [ 'Argento pac','silver-bg', 'silver' ]
}

export default function IngotEdit ({ data, feed, masterKind, confine, _on_change })
{
  let s = SettingStruct({  }); // fetch settings from sec_storage.
  let d = {}, m = {};

  if ( data ) {
    d = data;
    m = data.modifiers;
  }

  let k = kParse[ d.kind ];

  var ingotData;
  switch ( masterKind ) {
    default:
    case 'XAU':
    case 'XAG':
      ingotData = eval_ingot_price();
      break;

    case 'XAUPAC':
    case 'XAGPAC':
      ingotData = eval_pac_price();
      break;
  }


  const [ fee, set_fee ] = useState( m.fee );
  const [ canApply, set_can_apply ] = useState( false );

  return (
    <>
      { data &&
        <div className="main-ingot--">

         <div className = { `gr-ingot ${ confine ? 'gr-confine' : '' } ${ k[1] }` }>
            <img
                src       = { gekoDark }
                alt       = 'G'
                loading   = 'lazy' />

            {( masterKind === 'XAU' || masterKind === 'XAG' ) &&
              <div className = 'gr-data'>
                <p>{ m.weight && `${m.weight} Gr.` }</p>
                <p>{ d.kind && k[0] }</p>
                <p>{ ` fee: ${(( m.fee - 1 ) * 100).toFixed(1)}% - reps: ${feed.REPS | 0}` }</p>
              </div>
            }

            {( masterKind === 'XAUPAC' || masterKind === 'XAGPAC' ) &&
              <div className = 'gr-data'>
                <p>{ m.weight && `${ m.weight } Gr.` }</p>
                <p>{ d.kind && k[0] }</p>
              </div>
            }

          </div>

          {( masterKind === 'XAU' || masterKind === 'XAG') &&
            <div className="ingot-price--">
              <div className = {'admin-edits'}>
                <div className='price silver'>{ ingotData } </div>
                <label>cambia fee:</label>
                <input
                  className = ''
                  type     = 'number'
                  step     = '0.001'
                  value    = { fee }
                  onChange = { e => change_fee( e ) } />

                <button
                  className = ''
                  disabled  = { ! canApply }
                  onClick   = { () => apply_ingot_changes( fee ) }

                >conferma</button>
              </div>
            </div>
          }

          {( masterKind === 'XAUPAC' || masterKind === 'XAGPAC') &&
            <div className="ingot-price--">

                <div  className = {`pac-price ${ k[2] }`}>
                  <div className='text-left'>obiettivo:</div>
                  <div className='text-right silver'>{ ingotData.obiettivo }</div>
                </div>

                <div  className = {`pac-price ${ k[2] }`}>
                  <div className='text-left'>rate totali:</div>
                  <div className='text-right silver'>{ ingotData.rate }</div>
                </div>

                <div  className = {`pac-price ${ k[2] }`}>
                  <div className='text-left'>durata:</div>
                  <div className='text-right silver'>{ ingotData.duration }</div>
                </div>

                <div  className = {`pac-price ${ k[2] }`}>
                  <div className='text-left'>rata mensile:</div>
                  <div className='text-right silver'>{ ingotData.rata }</div>
                </div>

                <div  className = {`pac-price ${ k[2] }`}>
                  <div className='text-left'>gestione:</div>
                  <div className='text-right silver'>{ ingotData.gestione }</div>
                </div>


            </div>
          }

        </div>
      }
    </>
  )

  function eval_ingot_price ( )
  { return to_euro( ( feed[d.kind] * parseFloat( m.fee ) ) * parseFloat( m.weight ) ); }

  function eval_pac_price ( )
  {
    var currentPrice = feed[d.kind];
    var hRanges = {};
    var hFee = 0.0;
    var evalRange = false;

    // CALCULARE PRICE
    switch ( d.kind ) {
      default:
      case 'XAUPAC':

        if ( evalRange ) {

          if ( m.weight >= s.pac_ranges.XAU.range_a.min && m.weight <= s.pac_ranges.XAU.range_a.max ) {
            currentPrice *= s.pac_ranges.XAU.range_a.fee;
          }

          if ( m.weight >= s.pac_ranges.XAU.range_b.min && m.weight <= s.pac_ranges.XAU.range_b.max ) {
            currentPrice *= s.pac_ranges.XAU.range_b.fee;
          }

          if ( m.weight >= s.pac_ranges.XAU.range_c.min && m.weight <= s.pac_ranges.XAU.range_c.max ) {
            currentPrice *= s.pac_ranges.XAU.range_c.fee;
          }
        } else {
          currentPrice *= 1.10;  // hardcoded multiplier.
        }

        hRanges = s.pac_ranges.management_range.XAU;
        break;

      case 'XAGPAC':

        if ( evalRange ) {

          if ( m.weight >= s.pac_ranges.XAG.range_a.min && m.weight <= s.pac_ranges.XAG.range_a.max ) {
            currentPrice *= s.pac_ranges.XAG.range_a.fee;
          }

          if ( m.weight >= s.pac_ranges.XAG.range_b.min && m.weight <= s.pac_ranges.XAG.range_b.max ) {
            currentPrice *= s.pac_ranges.XAG.range_b.fee;
          }

          if ( m.weight >= s.pac_ranges.XAG.range_c.min && m.weight <= s.pac_ranges.XAG.range_c.max ) {
            currentPrice *= s.pac_ranges.XAG.range_c.fee;
          }
        } else {
          currentPrice *= 1.30; 
        }

        hRanges = s.pac_ranges.management_range.XAG;
        break;
    }

    let price = currentPrice * parseFloat( m.weight );

    // CALCULATE HANDLING
    hFee = price * hRanges.fee;       // Gestione base

    if ( hFee < hRanges.min ) {           // check minimo
      hFee = hRanges.min;
    } else if ( hFee > hRanges.max ) {       // check massimo
      hFee = hRanges.max;
    }

    let obiettivo = to_euro( price );
    let rate = m.duration;
    let duration = rate / 12;
    let rata = to_euro( price / m.duration );
    let gestione = to_euro( hFee );

    return { obiettivo, rate, duration, rata, gestione };
  }

  function apply_ingot_changes ( change )
  {
    _on_change( change );
    set_can_apply( false );
    return;
  }

  function change_fee ( e )
  {
    set_fee( e.target.value );
    set_can_apply( true );
  }
}
